import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchCountryIfNeeded } from '@lootboy/lib/actions/CountryActions';
import { fetchDailyQuestsIfNeeded } from '@lootboy/lib/actions/DailyQuestsActions';
import { fetchIntervalProgressIfNeeded } from '@lootboy/lib/actions/IntervalProgressActions';
import { fetchOffersIfNeeded } from '@lootboy/lib/actions/OfferActions';
import { useForceUpdate } from '@lootboy/lib/hooks';
import { NOOP } from '@lootboy/lib/utils';

import { loggedSelector } from '~/redux/selectors';

const useDailyQuestsHook = () => {
  const dispatch = useDispatch();
  const update = useForceUpdate();
  const isLoggedIn = useSelector(loggedSelector);
  useEffect(() => {
    dispatch(fetchCountryIfNeeded())
      .then((country) =>
        dispatch(
          fetchOffersIfNeeded({
            country,
            platform: 'web',
          }),
        ),
      )
      .catch(NOOP);
    dispatch(fetchDailyQuestsIfNeeded()).catch(NOOP);
    dispatch(fetchIntervalProgressIfNeeded()).catch(NOOP);
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    const timeToReset = new Date().setUTCHours(24, 0, 0, -1) - new Date();
    const timeoutId = setTimeout(() => update(), timeToReset);
    return () => clearTimeout(timeoutId);
  }, [update]);
};
export default useDailyQuestsHook;
